






























import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";

import FormActionButton from "@/components/falcon/shared/FormActionButton.vue";
import FilterOptionsForm from "@/components/falcon/shared/FilterOptionsForm.vue";
import PaymentsFiltersStatusFormField from "@/components/falcon/payments/PaymentsFiltersStatusFormField.vue";
import SortOptionsForm from "@/components/falcon/shared/SortOptionsForm.vue";
import PaginationOptionsForm from "@/components/falcon/shared/PaginationOptionsForm.vue";
import TableInlinePagination from "@/components/falcon/shared/TableInlinePagination.vue";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { FalconFilterOptions } from "@/interfaces/falcon/shared/falcon-filter-options";
import { FalconSortOptions } from "@/interfaces/falcon/shared/falcon-sort-options";
import { FalconPaginationOptions } from "@/interfaces/falcon/shared/falcon-pagination-options";
import { GetMyPaymentsFalconRequest } from "@/interfaces/falcon/get-my-payments/get-my-payments-falcon-request";

import { FalconPaymentStatus } from "@/enums/falcon/falcon-payment-status.enum";
import { RequestAlias } from "@/enums/request-alias.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon payments forms component
 */
@Component({
  components: {
    TableInlinePagination,
    PaginationOptionsForm,
    FormActionButton,
    PaymentsFiltersStatusFormField,
    FilterOptionsForm,
    SortOptionsForm
  },
  filters: {
    ...capitalizeFilter
  }
})
export default class PaymentsForms extends Vue {
  @Action("falconPayments/getPayments") private getPayments!: (
    request: GetMyPaymentsFalconRequest
  ) => void;
  private filterOptions: FalconFilterOptions = {};
  private sortOptions: FalconSortOptions = {};
  private paymentStatus: FalconPaymentStatus | null = null;

  @State(state => state.falconPayments.paymentsTotalCount)
  paymentsTotalCount!: number;
  paginationOptions: FalconPaginationOptions = {};
  requestAliasEnum = RequestAlias;
  i18nMessageKeyEnum = I18nMessageKey;

  mounted(): void {
    this.paymentsFetchRequested();
  }

  setFilterOptions(filterOptions: FalconFilterOptions): void {
    this.filterOptions = filterOptions;
    this.clearPaginationOptions();
  }

  setSortOptions(sortOptions: FalconSortOptions): void {
    this.sortOptions = sortOptions;
  }

  setPaymentStatus(paymentStatus: FalconPaymentStatus): void {
    this.paymentStatus = paymentStatus;
    this.clearPaginationOptions();
  }

  setPaginationOptions(paginationOptions: FalconPaginationOptions): void {
    this.paginationOptions = paginationOptions;
  }

  setPageNumber(pageNumber: number): void {
    this.setPaginationOptions({
      ...this.paginationOptions,
      pageNumber
    });
    this.paymentsFetchRequested();
  }

  setPageSize(pageSize: number): void {
    this.setPaginationOptions({
      ...this.paginationOptions,
      pageSize
    });
  }

  paymentsFetchRequested(): void {
    this.getPayments({
      getMyPayments: {
        paymentStatus: this.paymentStatus as FalconPaymentStatus,
        filterOptions: this.filterOptions,
        sortOptions: this.sortOptions,
        ...this.paginationOptions
      }
    });
  }

  private clearPaginationOptions(): void {
    this.paginationOptions.pageNumber = 1;
  }
}
